// extracted by mini-css-extract-plugin
export default {"content":"Header_content__f3vAG","intro":"Header_intro__q4Jep","ht":"Header_ht__GKt67","main":"Header_main__lBx+8"};